module.exports = __webpack_public_path__ + "img/Workflow_icon05.d47e4712.png";